var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 16H16V496H176V16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H176V496H496V16Z",
    fill: "#479951"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.797 180.031C284.412 190.058 261.672 219.445 261.672 254.156C261.672 297.134 296.538 331.969 339.516 331.969C370.998 331.969 398.075 313.27 410.328 286.375C409.183 287.542 408.037 288.679 406.797 289.781C377.352 315.955 332.252 313.32 306.078 283.875C279.905 254.43 282.571 209.33 312.016 183.156C313.252 182.057 314.508 181.029 315.797 180.031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.678 195.933L389.457 232.809L341.262 222.243L386.464 202.463L361.521 245.034L356.678 195.933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPk);
export default __webpack_public_path__ + "static/media/PK.0735edb2ec4e8fdd7d30ea9a9e075157.svg";
export { ForwardRef as ReactComponent };